import { render } from "./ManageOnDesktop.vue?vue&type=template&id=cc64a244"
import script from "./ManageOnDesktop.vue?vue&type=script&lang=js"
export * from "./ManageOnDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__